import { Flex, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

const Number: FunctionComponent = ({ children, ...rest }) => (
  <Flex
    {...rest}
    alignChildren="middle"
    backgroundColor="grape-1"
    borderRadius="rounded"
    direction="horizontal"
    height="80px"
    textColor="violet-2"
    width="80px"
  >
    <Text config="4" lineHeight="1" weight="medium">
      {children}
    </Text>
  </Flex>
);

export default Number;
